<template>
  <NuxtLayout name="search">
    <slot />
  </NuxtLayout>
  <AppFooter />
</template>
